export { AtlassianStartLogo } from './logo';